module.exports = __webpack_public_path__ + "static/media/product-team.396cc9dc.svg";